<template>
<div>
  <el-table height="360px" :data="tableContent" border highlight-current-row ref="singleTable" size="mini">
    <el-table-column
      prop="service_name"
      label="服务内容"
      min-width="90"
      align="center">
    </el-table-column>
    <el-table-column
      label="服务类型"
      min-width="70"
      align="center">
      <template slot-scope="scope">
        <span v-if="scope.row.st_id !== 0">{{getUpTypeName(scope.row.st_id)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="time_duration"
      label="服务时长(分钟)"
      min-width="100"
      align="center">
    </el-table-column>
    <el-table-column
      label="服务价格"
      min-width="70"
      align="center">
      <template slot-scope="scope">
        <span v-if="scope.row.price !== ''">{{parseFloat(scope.row.price) / 100}}元</span>
      </template>
    </el-table-column>
  </el-table>
</div>
</template>

<script>
import {querysupplierservice} from '../../../api/serviceMark'

export default {
  name: 'seeContent',
  model: {
    prop: 'seeShow',
    event: 'change'
  },
  props: {
    addEdit: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      tableContent: [],
      types: [],
      providerRow: ''
    }
  },
  created () {
    this.types = this.addEdit.types
    this.providerRow = this.addEdit.row
    this.querySupplierAndType()
  },
  methods: {
    querySupplierAndType () {
      let params = {
        page: 1,
        size: 99999
      }
      let data = {
        so_id: this.providerRow.id
      }
      querysupplierservice(params, data).then(res => {
        this.tableContent = res.data.service
      }).catch(() => {})
    },
    getUpTypeName (upid) {
      let name = ''
      let upids = this.getOrgName1(parseInt(upid), [])
      for (let i = 0; i < upids.length; i++) {
        for (let j = 0; j < this.types.length; j++) {
          if (parseInt(upids[i]) === this.types[j].id) {
            name = this.types[j].typename + ' / ' + name
          }
        }
      }
      return name !== '' ? name.substring(0, name.length - 3) : ''
    },
    getOrgName1 (upid, arr) {
      arr.push(upid)
      for (let i = 0; i < this.types.length; i++) {
        if (parseInt(upid) === this.types[i].id) {
          arr = this.getOrgName1(this.types[i].upid, arr)
        }
      }
      return arr
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/serviceprovider/childComponents/seeContent.vue